const INITIALSTATE = {
    currentax: null,
    currentpayment: null,
    alltaxes: [],
    allpayments: [],
    displayaddtax: false,
    displayaddpayment: false,
}

const LoadTaxReducer = (state = INITIALSTATE, action) => {
    console.log(action)
    switch (action.type) {
        case "LoadAllTaxes":
            return { ...state, alltaxes: action.data };
        case "ShowAddTax" :
            return { ...state, displayaddtax: true };
        case "HideAddTax" :
            return { ...state, displayaddtax: false };
        case "SetTax" :
            return { ...state, currentax: action.data };
        case "LoadAllPayments":
            return { ...state, allpayments: action.data };
        case "ShowAddTaxPayment" :
            return { ...state, displayaddpayment: true };
        case "HideAddTaxPayment" :
            return { ...state, displayaddpayment: false };
        case "SetTaxPayment" :
            return { ...state, currentpayment: action.data };
        default: return state;

    };
}

export default LoadTaxReducer;